import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'
import ShopActiveFilters from '../shop/shop-active-filters'
import Shop from '../shop/shop'

class FilterRemoveBtn extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('keydown', this.handleKeyDown)
    this.addEventListener('click', this.handleButtonClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('keydown', this.handleKeyDown)
    this.removeEventListener('click', this.handleButtonClick)
  }

  handleButtonClick = (): void => {
    this.update()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      event.preventDefault()

      this.update()
    }
  }

  update(): void {
    const shopActiveFilters = this.closest<ShopActiveFilters>(
      'shop-active-filters',
    )
    const shop = this.closest<Shop>('shop-component')
    const url = this.dataset.url

    if (shopActiveFilters) {
      const isRemoveButton = this.hasAttribute(
        'data-shop-active-filters-remove-btn',
      )
      const isResetButton = this.hasAttribute('data-shop-active-filters-reset')

      if (isResetButton) {
        shopActiveFilters.reset()
      }

      if (isRemoveButton) {
        const withSingleActiveFilter = shopActiveFilters.buttons.length === 1

        if (withSingleActiveFilter) {
          shopActiveFilters.reset()
        } else {
          shopActiveFilters.setDisable()

          this.remove()
        }
      }
    }

    if (url && shop) {
      const searchParams =
        url.indexOf('?') === -1 ? '' : url.slice(url.indexOf('?') + 1)

      shop.resetQueries()
      shop.updateBySearchParams(searchParams)
    }
  }
}

export default FilterRemoveBtn
